import {FlatList, Image, Text, TouchableOpacity, View} from 'react-native';
import {createStyles} from '../../../utils/createStyles';
import LinearGradient from 'react-native-linear-gradient';
import {useFocusEffect, useNavigation} from '@react-navigation/native';
import {getCorrectionCountForUserFirstPage} from '../../../API/wrong';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../../components/Loading/GlobalLoading';
import {useCallback, useEffect, useState} from 'react';
import {subjectsInfo} from './subjectsInfo';
interface TopType {
  todayQuestionCt: number;
  todayKpointCt: number;
  questionCt: number;
  kpointCt: number;
  navigation: any;
}
const Top: React.FC<TopType> = ({
  questionCt,
  todayQuestionCt,
  kpointCt,
  todayKpointCt,
  navigation,
}) => {
  const toStatistics = () => {
    navigation.navigate('WrongStatistics', {
      questionCt,
      todayQuestionCt,
      kpointCt,
      todayKpointCt,
    });
  };
  return (
    <View style={[styles.flexRow, styles.justifyBetween]}>
      <LinearGradient
        colors={['#FF5D5D', '#FF8484']}
        style={[styles.wqTopItem]}>
        <View style={[styles.wqTopItemTitle]}>
          <Text style={styles.wqTopItemTitleText}>
            {todayQuestionCt}
            <Text style={{fontSize: 15}}>道</Text>
          </Text>
        </View>
        <TouchableOpacity onPress={toStatistics} style={[styles.wqTopItemDesc]}>
          <Image
            style={styles.wqTopItemDescLeftIcon}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/wrong_icon1.png',
            }}
          />
          <Text style={[styles.wqTopItemDescText]}>今日收集错题</Text>
          <Image
            style={styles.wqTopItemDescRightIcon}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/wrong_icon_right.png',
            }}
          />
        </TouchableOpacity>
      </LinearGradient>
      <LinearGradient
        colors={['#FFBA36', '#FFDA48']}
        style={[styles.wqTopItem]}>
        <View style={[styles.wqTopItemTitle]}>
          <Text style={styles.wqTopItemTitleText}>
            {todayKpointCt || 0}
            <Text style={{fontSize: 15}}>个</Text>
          </Text>
        </View>
        <TouchableOpacity onPress={toStatistics} style={[styles.wqTopItemDesc]}>
          <Image
            style={styles.wqTopItemDescLeftIcon}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/wrong_icon2.png',
            }}
          />
          <Text style={[styles.wqTopItemDescText]}>今日未掌握知识点</Text>
          <Image
            style={styles.wqTopItemDescRightIcon}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/wrong_icon_right.png',
            }}
          />
        </TouchableOpacity>
      </LinearGradient>

      <LinearGradient
        colors={['#8A81FF', '#6F63FF']}
        style={[styles.wqTopItem]}>
        <View style={[styles.wqTopItemTitle]}>
          <Text style={styles.wqTopItemTitleText}>
            {questionCt}
            <Text style={{fontSize: 15}}>道</Text>
          </Text>
        </View>

        <TouchableOpacity onPress={toStatistics} style={[styles.wqTopItemDesc]}>
          <Image
            style={styles.wqTopItemDescLeftIcon}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/wrong_icon3.png',
            }}
          />
          <Text style={[styles.wqTopItemDescText]}>累计收集错题</Text>
          <Image
            style={styles.wqTopItemDescRightIcon}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/wrong_icon_right.png',
            }}
          />
        </TouchableOpacity>
      </LinearGradient>

      <LinearGradient
        colors={['#52E18D', '#37CE7B']}
        style={[styles.wqTopItem]}>
        <View style={[styles.wqTopItemTitle]}>
          <Text style={styles.wqTopItemTitleText}>
            {kpointCt || 0}
            <Text style={{fontSize: 15}}>个</Text>
          </Text>
        </View>

        <TouchableOpacity onPress={toStatistics} style={[styles.wqTopItemDesc]}>
          <Image
            style={styles.wqTopItemDescLeftIcon}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/wrong_icon4.png',
            }}
          />
          <Text style={[styles.wqTopItemDescText]}>累计未掌握知识点</Text>
          <Image
            style={styles.wqTopItemDescRightIcon}
            source={{
              uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/wrong_icon_right.png',
            }}
          />
        </TouchableOpacity>
      </LinearGradient>
    </View>
  );
};
interface SubjectListType {
  id: number;
  name: string;
  count: number;
}
const WrongQuestion = () => {
  const navigation = useNavigation();
  const toTgaManger = () => {
    console.log('toTagManger');
    navigation.navigate('TagManger');
  };
  const focusEffect = useCallback(() => {
    console.log('返回能触发');
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useFocusEffect(focusEffect);

  const [subjectList, setSubjectList] = useState<Array<SubjectListType>>([
    {id: 1, name: '语文', count: 0},
    {id: 2, name: '数学', count: 0},
    {id: 3, name: '英语', count: 0},
    {id: 4, name: '物理', count: 0},
    {id: 5, name: '化学', count: 0},
    {id: 6, name: '生物', count: 0},
    {id: 7, name: '政治', count: 0},
    {id: 8, name: '历史', count: 0},
    {id: 9, name: '地理', count: 0},
  ]); // 科目列表
  const [todayQuestionCt, settodayQuestionCt] = useState(0); // 昨日收集错题
  const [todayKpointCt, settodayKpointCt] = useState(0); // 昨日未掌握知识点
  const [questionCt, setQuestionCt] = useState(0); // 累计收集错题
  const [kpointCt, setKpointCt] = useState(0); // 累计未掌握知识点
  const getData = async () => {
    showGlobalLoading({text: '加载中...'});
    try {
      const res = await getCorrectionCountForUserFirstPage();
      console.log(res);
      if (res.status === 200) {
        const {
          countForSubjectList,
          questionCt: newQuestionCt,
          todayQuestionCt: newtodayQuestionCt,
          kpointCt: newKpointCt,
          todayKpointCt: newtodayKpointCt,
        } = res.data;
        const newSubjectList = subjectList.map(item => {
          const findItem = countForSubjectList.find(
            (i: any) => i.subjectId === item.id,
          );
          if (findItem) {
            return {
              ...item,
              count: findItem.questionCt,
            };
          }
          return item;
        });
        console.log('ccc', newtodayKpointCt);
        setSubjectList(newSubjectList);
        setKpointCt(newKpointCt);
        setQuestionCt(newQuestionCt);
        settodayKpointCt(newtodayKpointCt);
        settodayQuestionCt(newtodayQuestionCt);
      }
    } catch (e) {
      console.log(e);
    } finally {
      hideGlobalLoading();
    }
  };
  return (
    <View style={styles.wqBox}>
      <Top
        todayQuestionCt={todayQuestionCt}
        todayKpointCt={todayKpointCt}
        questionCt={questionCt}
        kpointCt={kpointCt}
        navigation={navigation}
      />
      <View style={[styles.wqCon]}>
        <View style={[styles.justifyBetween, styles.flexRow]}>
          <View style={styles.wqConTopLeft}>
            <View style={styles.wqConTopLeftShu} />
            <Text style={styles.wqConTopLeftText}>错题本</Text>
          </View>
          <TouchableOpacity
            onPress={toTgaManger}
            style={[styles.itemsCenter, styles.flexRow]}>
            <Text style={styles.wqConTopRightText}>标签管理</Text>
            <Image
              style={styles.wqConTopRightIcon}
              source={{
                uri: 'https://media.oss.leziedu.com/webapp/classroom/mylearn/wrong/wrong_icon_right_black.png',
              }}
            />
          </TouchableOpacity>
        </View>
        <View style={[styles.flex1, styles.subjectBox]}>
          <FlatList
            data={subjectList}
            numColumns={4}
            renderItem={({item}) => {
              const {icon, bgColor, color} = subjectsInfo[item.id];
              return (
                <TouchableOpacity
                  onPress={() => {
                    navigation.navigate('WrongQuestionList', {
                      subject: item.id,
                    });
                  }}
                  style={[
                    styles.subjectItem,
                    styles.itemsCenter,
                    styles.flexRow,
                    {backgroundColor: bgColor},
                  ]}>
                  <Image style={styles.subjectItemImage} source={{uri: icon}} />
                  <View>
                    <Text style={[styles.subjectItemText, {color: color}]}>
                      {item.name}
                    </Text>
                    <Text style={styles.subjectItemDesc}>
                      累计错题{item.count}道
                    </Text>
                  </View>
                </TouchableOpacity>
              );
            }}
          />
        </View>
      </View>
    </View>
  );
};
const styles = createStyles({
  wqBox: {
    flex: 1,
    backgroundColor: '#fff',
    paddingHorizontal: '3.6rem',
    paddingRight: '7.95rem',
  },
  wqCon: {
    marginTop: '3.6rem',
    flex: 1,
  },
  flex1: {
    flex: 1,
  },
  flexRow: {
    flexDirection: 'row',
  },
  justifyBetween: {
    justifyContent: 'space-between',
  },
  itemsCenter: {
    alignItems: 'center',
  },
  wqTopItem: {
    width: '18.75rem',
    height: '9rem',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '0.75rem',
  },
  wqTopItemTitle: {
    marginBottom: '1.55rem',
  },
  wqTopItemTitleText: {
    fontSize: '2.4rem',
    color: '#ffffff',
  },
  wqTopItemDesc: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  wqTopItemDescText: {
    fontSize: '1.2rem',
    fontWeight: '500',
    color: '#ffffff',
  },
  wqTopItemDescLeftIcon: {
    width: '2.15rem',
    height: '2.15rem',
    marginRight: '0.6rem',
  },
  wqTopItemDescRightIcon: {
    width: '1.25rem',
    height: '1.25rem',
    marginLeft: '0.6rem',
  },
  wqConTopLeft: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  wqConTopLeftShu: {
    width: '0.35rem',
    height: '1.35rem',
    backgroundColor: '#695DF3',
    borderRadius: '0.41rem',
    marginRight: '1.05rem',
  },
  wqConTopLeftText: {
    fontSize: '1.8rem',
    color: '#3d3d3d',
  },
  wqConTopRightText: {
    fontSize: '1.4rem',
    color: '#3d3d3d',
  },
  wqConTopRightIcon: {
    width: '1.2rem',
    height: '1.2rem',
    marginLeft: '0.6rem',
  },
  subjectBox: {
    marginTop: '1.25rem',
  },
  subjectItem: {
    width: '18.75rem',
    height: '10.2rem',
    marginRight: '1rem',
    marginBottom: '1.5rem',
    borderRadius: '0.75rem',
    padding: '1.225rem',
  },
  subjectItemImage: {
    width: '8rem',
    height: '8rem',
    marginRight: '0.4rem',
  },
  subjectItemText: {
    fontSize: '1.8rem',
    marginBottom: '0.5rem',
  },
  subjectItemDesc: {
    color: '#666666',
    fontSize: '1.1rem',
  },
});
export default WrongQuestion;
